import React from "react";
import { AuthDialog } from "./AuthDialog";
import { AuthFormProps } from "./AuthForm";

/** Сессия истекла: то же окно входа, что и на странице авторизации */
export const AuthPopup = ({ store }: AuthPopupProps) => {
    return <AuthDialog store={store} note="Сессия истекла — войдите снова" />;
};

interface AuthPopupProps extends AuthFormProps {}
